import React, { FC } from 'react';
import AiTokenConsumptionComponent from './AiTokenConsumption';

const AiTokenConsumption: FC = () => {
  return <AiTokenConsumptionComponent />;
};

export default AiTokenConsumption;
